//@flow
import * as actionTypes from './actionTypes';
import {
    submitTaskApi,getTaskApi,getVendorsApi,getLineItemsApi,createLineItemApi,updateLineItemApi,
    moveDownLineItemApi,moveUpLineItemApi,deleteLineItemApi
} from '../../apiUtils/api';
import { transformDataToEditFormData } from './editFormData'
import { getReviewOutcome } from '../demeter/submitFormData'
import type { Dispatch$Type,ReducerState$Type } from '../genericFlowTypes'
import type { EditFormData,PostPayloadData  } from '../phobos/flowTypes'

const workflowType = 'Deimos'

export const getTaskData=(deimos:ReducerState$Type, jwt:string,taskAcceptedInfoId: number)=>{
    return (dispatch:Dispatch$Type) => getTaskApi(jwt,workflowType,taskAcceptedInfoId.toString())
    .then((res)=>res.json()).then((data)=>{
        const error = (data.error:any|null)
        if (error){
            dispatch({type: actionTypes.DEIMOS_EDIT_VERIFY_FORM_DATA_ERROR,error: error});
        }else {
            const formData = transformDataToEditFormData(data,deimos)
            dispatch({
                type: actionTypes.DEIMOS_EDIT_VERIFY_FORM_DATA_SUCCESS, 
                formData: formData,reviewQuestions: data['reviewQuestions'] });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.DEIMOS_EDIT_VERIFY_FORM_DATA_ERROR, error: err});
    })
}

export const invoiceSubmissionCompleted = () => {
    return { type: actionTypes.DEIMOS_INV_SUBMITTED_COMPLETED };
}

export const invoiceSubmission = (jwt:any,taskAcceptedInfoId:number,deimosResultset:any,deimos:ReducerState$Type)=>{
    let payload:PostPayloadData={
        taskAcceptedInfoId:taskAcceptedInfoId
    };

    if (deimosResultset.isInvalidDoc){
        payload.isInvalidDoc=true;
    }else {
        payload.vendorName=deimosResultset.vendorName;
        payload.invNo=deimosResultset.invNo;
        payload.invDate=deimosResultset.invDate;
        payload.serviceAddr=deimosResultset.serviceAddr;
        payload.total=deimosResultset.total;
        payload.isInvalidDoc=deimosResultset.isInvalidDoc?deimosResultset.isInvalidDoc:false;
        payload.isOverrideTotal=deimosResultset.isOverrideTotal?deimosResultset.isOverrideTotal:false;
        payload.poNo=deimosResultset.poNo?deimosResultset.poNo:'';
        payload.isOverrideVendorName=deimosResultset.isOverrideVendorName?deimosResultset.isOverrideVendorName:false;
    }

    if (deimos.reviewQuestions && deimos.reviewQuestions.length > 0){
        payload.reviewOutcome=getReviewOutcome(deimosResultset,deimos.reviewQuestions)
    }
    
    return (dispatch:Dispatch$Type) => submitTaskApi(jwt,payload).then((res)=>res.json()).then((data) =>{
        if (data['error']){
            dispatch({type: actionTypes.DEIMOS_INV_SUBMIT_ERROR, error: data.error});
        }else {
            dispatch({type: actionTypes.DEIMOS_INV_SUBMIT_SUCCESS});
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.DEIMOS_INV_SUBMIT_ERROR, error: err});
    })
}

export const updateFormError=(error:any|null)=>{
    return { type: actionTypes.DEIMOS_UPDATE_FORM_ERROR, formError: error }
}

export const populateVendorsList=(jwt:any)=>{
    return (dispatch:Dispatch$Type) => getVendorsApi(jwt,workflowType).then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.REFRESH_DEIMOS_VENDORS_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.REFRESH_DEIMOS_VENDORS_SUCCESS, vendors: data.vendors });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.REFRESH_DEIMOS_VENDORS_ERROR, error: err});
    })
}

export const getLineItems=(jwt:any,page:number,pageSize:number,sortField:string,sortOrder:any,taskAcceptedInfoId:number)=>{
    return (dispatch:Dispatch$Type) => getLineItemsApi(jwt,workflowType,page,pageSize,sortField,sortOrder,taskAcceptedInfoId)
    .then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.GET_DEIMOS_ITEMS_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.GET_DEIMOS_ITEMS_SUCCESS, data: data });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.GET_DEIMOS_ITEMS_ERROR,error: err});
    })
}

export const setPage=(jwt:any,deimos:ReducerState$Type,page:number)=>{
    return getLineItems(jwt,page,(deimos.pageSize:any),(deimos.sortField:any),deimos.sortOrder,(deimos.taskAcceptedInfoId:any));
}

export const setPageSize=(jwt:any,deimos:ReducerState$Type,pageSize:number)=>{
    return getLineItems(jwt,(deimos.page:any),pageSize,(deimos.sortField:any),deimos.sortOrder,(deimos.taskAcceptedInfoId:any));
}

export const sortData=(jwt:any,deimos:ReducerState$Type,sortField:any,sortOrder:any)=>{
    return getLineItems(jwt,(deimos.page:any),(deimos.pageSize:any),sortField,sortOrder,(deimos.taskAcceptedInfoId:any));
}

export const createNewLineItem=(jwt:any,newLineItem:any,taskAcceptedInfoId:number)=>{
    return (dispatch:Dispatch$Type) => createLineItemApi(jwt,workflowType,newLineItem,taskAcceptedInfoId)
    .then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.CREATE_NEW_DEIMOS_ITEM_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.CREATE_NEW_DEIMOS_ITEM_SUCCESS, data: data });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.CREATE_NEW_DEIMOS_ITEM_ERROR,error: err});
    })
}

export const editLineItem=(lineItem:any)=>{
    let convertToFormObj={};
    convertToFormObj.id=lineItem.id;
    convertToFormObj.itemDesc=lineItem.item_desc;
    convertToFormObj.itemAmount=lineItem.item_amount;
    
    return { type: actionTypes.EDIT_DEIMOS_ITEM, lineItem: convertToFormObj };
}

export const updateLineItem=(jwt:any,updateLineItem:any,id:number)=>{
    return (dispatch:Dispatch$Type) => updateLineItemApi(jwt,workflowType,updateLineItem,id)
    .then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.UPDATE_DEIMOS_ITEM_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.UPDATE_DEIMOS_ITEM_SUCCESS });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.UPDATE_DEIMOS_ITEM_ERROR,error: err});
    })
}

export const moveDownLineItem=(jwt:any,id:number)=>{
    return (dispatch:Dispatch$Type) => moveDownLineItemApi(jwt,workflowType,id)
    .then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.MOVE_DOWN_DEIMOS_ITEM_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.MOVE_DOWN_DEIMOS_ITEM_SUCCESS });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.MOVE_DOWN_DEIMOS_ITEM_ERROR,error: err});
    })
}

export const moveUpLineItem=(jwt:any,id:number)=>{
    return (dispatch:Dispatch$Type) => moveUpLineItemApi(jwt,workflowType,id)
    .then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.MOVE_UP_DEIMOS_ITEM_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.MOVE_UP_DEIMOS_ITEM_SUCCESS });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.MOVE_UP_DEIMOS_ITEM_ERROR,error: err});
    })
}

export const deleteLineItem=(jwt:any,id:number)=>{
    return (dispatch:Dispatch$Type) => deleteLineItemApi(jwt,workflowType,id)
    .then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.DELETE_DEIMOS_ITEM_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.DELETE_DEIMOS_ITEM_SUCCESS });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.DELETE_DEIMOS_ITEM_ERROR,error: err});
    })
}

export const openAddEditLineItemForm=()=>{
    return { type: actionTypes.OPEN_ADD_EDIT_LINEITEM_FORM };
}

export const lineItemSelectedId=(id:number)=>{
    return { type: actionTypes.SELECTED_DEIMOS_ITEM_ID, lineItemId: id}
}

export const cancelAddEditLineItemForm=()=>{
    return { type: actionTypes.CANCEL_ADD_EDIT_LINEITEN_FORM };
}


// WEBPACK FOOTER //
// ./src/redux/deimos/actions.js